import * as zod from 'zod';

import { TCPOptionOrAuto } from '@sb/motion-planning';
import { BlendConfig } from '@sb/motion-planning/Waypoint';

import { SpeedProfile } from '../../speed-profile';

export default zod.object({
  speedProfile: SpeedProfile,
  blendConfig: BlendConfig,
  moveDynamicBaseToReachPosition: zod.boolean().optional(),
  enforceConstantSpeed: zod.boolean().optional(),
  constantSpeedValue: zod.number().positive().optional(),
  constantSpeedAcceleration: zod.number().positive().optional(),
  constantSpeedTCPOption: TCPOptionOrAuto.optional(),
});
